import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { horasEmProsa } from "../api.ts";
import { Cartao, SeloStatus, Vazio } from "../componentes/basicos.tsx";
import { useDados } from "../usarDados.ts";

type Maquina = {
  id: number; hostname: string; apelido: string; fingerprint: string;
  empresa: string; licenca_apelido: string; status: string;
  silencio_horas: number; tolerancia_h: number; razao: number;
  versao_app: string; ultimo_erro: string;
};

const STATUS: [string, string][] = [
  ["", "Todas"], ["ativa", "Ativas"], ["liberada", "Liberadas"], ["bloqueada", "Bloqueadas"],
];
/** Os baldes batem com os do painel: e o que faz o clique no grafico chegar
 *  numa lista coerente. */
const SILENCIO: [string, string][] = [
  ["", "Qualquer"], ["0-24h", "0–24 h"], ["1-7d", "1–7 dias"],
  ["7-30d", "7–30 dias"], ["30d+", "+30 dias"], ["alem-tolerancia", "Alem da tolerancia"],
];

const curto = (f: string) => f.replace(/^sha256:/, "").slice(0, 8);

export function Maquinas() {
  const [params, setParams] = useSearchParams();
  const [busca, setBusca] = useState("");
  const status = params.get("status") ?? "";
  const silencio = params.get("silencio") ?? "";

  const q = new URLSearchParams();
  if (busca) q.set("busca", busca);
  if (status) q.set("status", status);
  if (silencio) q.set("silencio", silencio);

  const { dados, erro, carregando } = useDados<Maquina[]>(`/maquinas?${q}`);

  const trocar = (chave: string, valor: string) => {
    const p = new URLSearchParams(params);
    if (valor) p.set(chave, valor); else p.delete(chave);
    setParams(p);
  };

  return (
    <>
      <h1>Maquinas</h1>
      <Cartao>
        <div className="linha" style={{ marginBottom: "var(--e-md)" }}>
          <input className="entrada" type="search" value={busca} style={{ flex: 1, minWidth: 240 }}
                 placeholder="Buscar por computador, apelido, empresa ou digital"
                 onChange={(e) => setBusca(e.target.value)} />
        </div>
        <div className="chips" style={{ marginBottom: "var(--e-sm)" }}>
          {STATUS.map(([v, r]) => (
            <button key={v} type="button" className={`chip${status === v ? " chip--ativo" : ""}`}
                    onClick={() => trocar("status", v)}>{r}</button>
          ))}
        </div>
        <div className="chips" style={{ marginBottom: "var(--e-md)" }}>
          <span className="micro apagado" style={{ alignSelf: "center", marginRight: 4 }}>Silencio:</span>
          {SILENCIO.map(([v, r]) => (
            <button key={v} type="button" className={`chip${silencio === v ? " chip--ativo" : ""}`}
                    onClick={() => trocar("silencio", v)}>{r}</button>
          ))}
        </div>

        {carregando && <div className="carregando">carregando...</div>}
        {erro && <div className="alerta alerta--erro">{erro}</div>}
        {dados && dados.length === 0 && <Vazio titulo="Nenhuma maquina neste filtro" />}

        {dados && dados.length > 0 && (
          <div className="tabela-rolagem">
            <table className="tabela">
              <thead>
                <tr>
                  <th>Computador</th><th>Empresa</th><th>Licenca</th><th>Status</th>
                  <th>Silencio</th><th>Versao</th><th>Ultimo erro</th><th>Digital</th>
                </tr>
              </thead>
              <tbody>
                {dados.map((m) => (
                  <tr key={m.id}>
                    <td>
                      <Link to={`/maquinas/${m.id}`}>{m.hostname || "sem nome"}</Link>
                      {m.apelido && <span className="suave pequeno"> &middot; {m.apelido}</span>}
                    </td>
                    <td className="suave pequeno">{m.empresa}</td>
                    <td className="suave pequeno">{m.licenca_apelido}</td>
                    <td><SeloStatus status={m.status} /></td>
                    <td className="pequeno">
                      {horasEmProsa(m.silencio_horas)}
                      {m.razao > 1 && (
                        <span className="apagado micro"> &middot; {m.razao.toFixed(1)}x a tolerancia</span>
                      )}
                    </td>
                    <td className="suave pequeno">{m.versao_app}</td>
                    <td className="tabela__erro" title={m.ultimo_erro}>{m.ultimo_erro}</td>
                    {/* A digital fica no fim: e um hash, serve para conferir por
                        telefone, nao para varrer com o olho. */}
                    <td className="tabela__mono">{curto(m.fingerprint)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Cartao>
    </>
  );
}
